import { MenuItem, MenuButton } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { Scalars } from '@bechtel/types';
interface MenuItemStyledProps {
  isActive: Scalars['Boolean'];
  isDisabled: Scalars['Boolean'];
}
export const MenuItemStyled = styled(MenuItem)<MenuItemStyledProps>`
  ${({ theme }) => css`
    font-size: ${theme.fontSizes[400]};
    padding-left: ${theme.spacings[500]};
    color: ${theme.colors.grey[1000]};
    white-space: nowrap;

    &:not(:last-child) {
      border-bottom: 1px solid ${theme.colors.bechtel.blue[100]};
    }
    ${(props: MenuItemStyledProps) =>
      props.isActive &&
      css`
        background-color: ${theme.colors.bechtel.blue[100]};
        &:hover {
          background-color: ${theme.colors.bechtel.blue[100]};
        }
      `}
    ${(props: MenuItemStyledProps) =>
      props.isDisabled &&
      css`
        pointer-events: none;
        opacity: 0.6;
      `}
  `}
`;

export const PopperContainerStyled = styled.div`
  border-radius: ${({ theme }) => theme.spacings[200]};
  display: flex;
  align-items: baseline;
  position: absolute;
  top: ${({ theme }) => theme.spacings[700]};
  right: 0;
  z-index: 1;
`;
interface MenuButtonProps {
  isDisabled: Scalars['Boolean'];
}
export const MenuButtonStyled = styled(MenuButton)<MenuButtonProps>`
  display: inline-flex;
  border-color: ${({ theme }) => theme.colors.blue[800]};
  pointer-events: all;
  opacity: 1;
  align-items: center;
  &:focus {
    box-shadow: none;
  }
  ${(props: MenuButtonProps) =>
    props.isDisabled &&
    css`
      pointer-events: none;
      opacity: 0.6;
    `}
`;
